import React from "react";

const ChatBubbleIcon = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="#667085"
      className="size-6"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3.75c-4.97 0-9 3.29-9 7.35 0 1.93.89 3.73 2.44 5.09l-.94 3.89 4.12-2.06c1.04.27 2.15.4 3.38.4 4.97 0 9-3.29 9-7.35s-4.03-7.32-9-7.32Z"
      />
    </svg>
  );
};

export default ChatBubbleIcon;
